document.addEventListener('DOMContentLoaded' , () =>{
    // company - biteme-interview-page
    if(document.querySelector('.biteme-interview-page')){
        let ytBtn = document.querySelectorAll('button.btn-more-inteview');
        let ytVideo = document.querySelector('#pop-youtube-video');
        let ytVideoWrap = document.querySelector('#popVideo');
        let ytVideoBg = document.querySelector('.yt-pop__bg');
        
        ytBtn.forEach((el) =>{
            el.addEventListener('click', pushVideo)
        })
        ytVideoBg.addEventListener('click', function(){
            ytVideoWrap.style.display = 'none';
            ytVideoWrap.classList.remove('active');
        })
        function pushVideo(e){
            ytVideoWrap.style.display = 'flex';
            ytVideoWrap.classList.add('active');
            let tyId = e.target.dataset.youtube;
            ytVideo.src=`https://www.youtube.com/embed/${tyId}`;
        }
    }
});
